class SizeSelector extends HTMLElement {
  constructor() {
    super();
    this.form = document.getElementById(this.dataset.productFormId);
    this.variantIdInput = this.form ? this.form.querySelector('.product-variant-id') : null;
    this.submitButton = this.form ? this.form.querySelector('[type="submit"]') : null;

    this.options = Array.from(this.querySelectorAll('.size-selector__option[data-variant-id]'));
    this.options.forEach((button) => {
      button.addEventListener('click', this.onSelect.bind(this, button));
    });

    // No size is selected on load — Add to cart stays disabled until a click.
    this.setDisabled(true);
    if (this.variantIdInput) this.variantIdInput.value = '';
  }

  onSelect(button) {
    this.options.forEach((option) => option.setAttribute('aria-pressed', option === button ? 'true' : 'false'));

    if (this.variantIdInput) {
      this.variantIdInput.value = button.dataset.variantId;
      this.variantIdInput.disabled = false;
    }
    this.setDisabled(false);
  }

  setDisabled(disabled) {
    if (!this.submitButton) return;
    this.submitButton.disabled = disabled;
    const label =
      this.submitButton.querySelector('.product-form__submit-text') || this.submitButton.querySelector('span');
    if (label) {
      const addToCart = window.variantStrings ? window.variantStrings.addToCart : 'Add to cart';
      label.textContent = disabled ? 'Select a size' : addToCart;
    }
  }
}

customElements.define('size-selector', SizeSelector);
